import momenttz from 'moment-timezone'
import { MATERIAL_NOT_FOUND, FINISH_NOT_FOUND, PLAN_CODES } from '../helpers/enum'
import { DateTime } from 'luxon';
import { SvgPending, SvgLost, SvgGiveUp, SvgWon } from '../assets/icons'

const getBrazilianFormatPrice = price => {
    return Number(price).toLocaleString('pt-br',{ style: 'currency', currency: 'BRL' })
}

const getIconWithStateName = (name, selected) => {
    
   switch (name) {
    case 'pending': return <SvgPending name="status_bar" selected={selected} />
    case 'sentiment_dissatisfied': return <SvgLost name="status_bar" selected={selected} />
    case 'sentiment_satisfied': return <SvgWon name="status_bar" selected={selected} />
    default: return <SvgGiveUp name="status_bar" selected={selected} />
   }

} 

const getRoleNameById = id => {

    switch (id) {
        case 5: return 'PARCEIRO'  
        default: return 'PARCEIRO (ADMIN)'
    }

}

const getNameFirstLetter = (string) => {
    if (typeof string === 'string') {
        const arry = string.split(' ')
        if (arry.length > 0) {
            return arry[0]
        }
    }
    return ''
}

const getFirstAndSecondName = (string) => {

    if (typeof string === 'string') {

        const arry = string.split(' ')

        if (arry.length > 1) {

            if ((arry[1].length <= 2) && arry[2]) {
                return `${arry[0]} ${arry[1]} ${arry[2]}`
            }

            return `${arry[0]} ${arry[1]}`
        }

    }

    return string
}

const getInitialsName = (name) => {
    if (typeof name === 'string') {

        const arry = name.split(' ')

        if (arry.length >= 3) {
            if (arry[1].length === 2) {
                return `${arry[0][0]}${arry[2][0]}`
            } else {
                return `${arry[0][0]}${arry[1][0]}`
            }
        } else if (arry.length > 1) {
            return `${arry[0][0]}${arry[1][0]}`
        } else {
            return arry[0][0]
        }
    }
    
    return name
} 

const getFirstName = (string) => {

    if (typeof string === 'string') {

        const arry = string.split(' ')

        if (arry.length > 1) {
            return `${arry[0]}`
        }

    }
    
    return string
}

export const transformMaterials = materials => {

    let material = materials.map(item => {

        return {
            name: item.name,
            description: item.description,
            materials: item.materials.filter(mat => mat.name).map(data => {
                return {
                    name: data.name,
                    finish: data.finish
                }
            })
        }

    })

    return material

}

export const getTimeFormated = (date, displayMinutesAndSeconds) => {

    const currentDate = DateTime.fromISO(date, { zone: "AMERICA/Sao_Paulo" })

    const sameTime = currentDate.hasSame(DateTime.local(), "day")

    if (sameTime) {
        const momentDate = momenttz(date).tz("AMERICA/Sao_Paulo").format('HH:mm')
        return `${momentDate}`
    }

    const momentDate = momenttz(date).tz("AMERICA/Sao_Paulo").format('DD/MM/YY')
    return `${momentDate}`
}

export const getDateByBrazilianFormat = (date, displayMinutesAndSeconds) => {
    if (displayMinutesAndSeconds) {
        const momentDate = momenttz(date).tz("AMERICA/Sao_Paulo").format('DD/MM/YYYY - HH:mm')
        return `${momentDate}`
    }
    const momentDate = momenttz(date).tz("AMERICA/Sao_Paulo").format('DD/MM/YYYY')
    return `${momentDate}`
}

const arrayFilter = filters => {

    let params = {}
    
    const keys = Object.keys(filters)

    for (let i = 0; i < keys.length; i+= 1) {
        const data = filters[keys[i]].filter(({ selected }) => selected)
        params[keys[i]] = data
    }

    return params 
    
}

const verifyIfProjectHasMaterials = (item, materials) => {

    let message = null

    const some = materials.some(item => item.name)

    if (some) {

        for ( let i = 0; i < materials.length; i++) {

            if (materials[i].name) {

                if (!materials[i].finish) {

                    message = {
                        item: materials[i].name,
                        message: `O material ${materials[i].name} está sem acabamento`,
                        type: FINISH_NOT_FOUND
                    }

                } 

            }

        }

    } else {

        message = {
          item: item.name,
          message: `O ambiente ${item.name} não possui material atrelado`,
          type: MATERIAL_NOT_FOUND
        }

    }

    return message

}


const firstLetterCapitalize = string => {
    return string && string.length > 1 ? `${string[0].toUpperCase()}${string.substring(1).toLowerCase()}` : string
}

export const getTimeDiferences = (start) => {

    const now = DateTime.local({ zone: 'AMERICA/Sao_Paulo' })

    const past = DateTime.fromISO(start, { zone: "AMERICA/Sao_Paulo" })

    const diff = now.diff(past, ["years", "months", "days", "hours"])
    
    const hours = Math.floor(diff.hours)
    
    const days = Math.floor(diff.days)
    
    const months = Math.floor(diff.months)
    
    const years = Math.floor(diff.years)

    if (years > 0) return `${years} ${years === 1 ? 'ano' : 'anos'} atrás`

    if (months > 0) return `${months} ${months === 1 ? 'mês' : 'mêses'} atrás`

    if (days > 0) return `${days} ${days === 1 ? 'dia' : 'dias'} atrás`

    return `${hours} ${hours === 1 ? 'hora' : 'horas'} atrás`

}

const getAttatchFileName = name => {

    const split = name.split('.')

    if (split.length > 1) {
        return `${split[0].substring(0, 8)}...${split[1]}`
    }

    return name

}

const removeObjectFromKey = (array, items) => {
    let copy = [...items]

    for (let i=0; i < array.length; i++) {
        copy = copy.filter(item => item.name !== array[i])
    }

    return copy
}

const getPlanNameByCode = code => {
    switch (code) {
        case PLAN_CODES.FREE_PLAN_CODE : {
            return 'Free'
        }
        case PLAN_CODES.MONTH_PLAN_CODE : {
            return 'Bronze'
        }
        case PLAN_CODES.SEMESTER_PLAN_CODE: {
            return 'Prata'
        }
        default: {
            return 'Ouro'
        }
    }
}

const getTypeOfLink = type => {

    switch (type) {
        case 'INSTALLER': return 'INSTALADOR'
        case 'MEASURER': return 'MEDIDOR'
        default: return 'CLIENTE'
    }

}

const getCookieValue = cname => {

    let name = cname + "=";

    let ca = document.cookie.split(';');

    for(let i = 0; i < ca.length; i++) {

      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return null;
}

const getPaymentName = type => {
    
    switch (type) {
        case 0: return 'Cartão de crédito'
        case 1: return 'Pix'
        default: return 'Dinheiro'
    }

}

function removeTypename (obj) {
    if (Array.isArray(obj)) {
      for (let i = 0; i < obj.length; i++) {
        obj[i] = removeTypename(obj[i]);
      }
    } else if (typeof obj === 'object' && obj !== null) {
      delete obj['__typename'];
      for (let key in obj) {
        obj[key] = removeTypename(obj[key]);
      }
    }
    return obj;
  }

const removeTypeNameFromData = rows => {
    const data = removeTypename(rows)
    return data
}

export {
    getNameFirstLetter,
    getFirstAndSecondName,
    verifyIfProjectHasMaterials,
    firstLetterCapitalize,
    getFirstName,
    getAttatchFileName,
    getInitialsName,
    getIconWithStateName,
    getPlanNameByCode,
    getBrazilianFormatPrice,
    removeObjectFromKey,
    arrayFilter,
    getCookieValue,
    getPaymentName,
    getRoleNameById,
    getTypeOfLink,
    removeTypeNameFromData
}